import Button from "./Button";
import Body from "./Body";

export default {
  Button,
  Body
};
